import { Component } from '@angular/core';

@Component({
    selector: 'splash',
    templateUrl: './splash.component.html',
    styleUrls: ['./splash.component.scss'],
    standalone: true
})
export class SplashComponent {

}
